const selectAttribute = (name, attributes) =>
  attributes.find(attribute => attribute.name === name)

const getPhotoResolution = itemAttributes => {
  if (!itemAttributes) return null

  const width = selectAttribute('max_width', itemAttributes).value
  const height = selectAttribute('max_height', itemAttributes).value
  const resolutionInMegapixels = selectAttribute(
    'full_resolution_in_megapixels',
    itemAttributes
  ).value

  return `${width} x ${height}px (${resolutionInMegapixels}MP)`
}
export default getPhotoResolution
